import React from "react";
import Table from "../../../../../../common/element/Table";

const AuditLogList = (props) => {
  const { Tr, Th, Td, THead, TBody } = Table;
  console.log(props?.auditData?.length,"Get");
  console.log(props?.auditData,"dsfdsfdfd");
  
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>
                <span
                  className="flex items-center gap-1"
                  onClick={() => props?.handleSort("created_date")}
                >
                  Timestamp
                  <svg
                    className={`transform ${props?.filtersort === "created_date" &&
                      props?.filterorder === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>User</Th>
              <Th className="w-7/12">
                <span className='flex items-center gap-1' onClick={() => props?.handleSort("audit_log_text")}>Action
                  <svg
                    className={`transform ${props?.filtersort === "audit_log_text" && props?.filterorder === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round" />
                  </svg></span>
              </Th>
              <Th>IP address</Th>
            </Tr>
          </THead>
          <TBody>
            {props?.auditData &&
              props?.auditData.map((item) => (
                <Tr key={item?.user_ip}>
                  <Td>{item?.createdDate ? item?.createdDate : "-"}</Td>
                  <Td>{item?.user ? item?.user : "-"}</Td>
                  <Td dangerouslySetInnerHTML={{ __html: item?.audit_log_text || "-" }} />
                  <Td>{item?.user_ip ? item?.user_ip : "-"}</Td>
                </Tr>
              ))}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default AuditLogList;
